module.exports = __webpack_public_path__ + "img/girl-sprite.f8aad998.png";